import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {AddressQualityComponent} from "./components/address-quality/address-quality.component";
import {CommonsModule} from "../../commons/angular/commons.module";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {TranslateModule} from "@ngx-translate/core";
import {NgxPermissionsModule} from "ngx-permissions";


@NgModule({
  declarations: [AddressQualityComponent],
  imports: [
    BrowserModule,
    CommonsModule,
    NgbModule,
    TranslateModule.forChild(),
    NgxPermissionsModule.forChild()
  ],
  providers: [],
  exports: [AddressQualityComponent]
})

export class AddressesModule {
  constructor() {}

  ngDoBootstrap(){
  }
}

const bootstrapAddressesModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(AddressesModule);
};

export const downgradedAddressesModule = downgradeModule(bootstrapAddressesModule);
